import {React} from "react";


function Bitmoji(props)
{    
    return(
        
        <div class="demo">
  <div class="box">
    <div class="hover-point"></div>
    <div class="hover-point"></div>
    <div class="hover-point"></div>
    <div class="hover-point"></div>
    <div class="hover-point"></div>
    <div class="hover-point"></div>
    <div class="hover-point"></div>
    <div class="hover-point"></div>
    <div class="box-contents"></div>
  </div>
</div>
    );
}
 
export default Bitmoji;